<template>
  <header class="gridx">
    <vs-navbar
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      text-color="rgba(255,255,255,0.7)"
      active-text-color="rgba(255,255,255,1)"
    >
      <!---
      Template logo
      -->
      <div slot="title" class="themelogo">
        <router-link to="/home">
          <span
            class="logo-text"
            style="margin-left: 12px;
    margin-right: 3px;
    font-size: 18px;    color: #fff;
    font-weight: 600;"
            v-if="title"
            >{{ title }}</span
          >
          <img :src="logo" v-if="logo" alt="Dashboard" style="height: 30px;" />
        </router-link>
        
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div class="hiddenDesktop cursor-pointer" @click.stop="activeSidebar">
          <vs-icon icon="menu"></vs-icon>
        </div>
      </div>
    </vs-navbar>
  </header>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    topbarColor: {
      type: String,
      default: "#2962ff",
    },
    title: {
      type: String,
    },
    logo: {
      type: String,
    },
  },
  data: () => ({
    indexActive: 0,
    showToggle: false,
  }),

  methods: {
    //This is for sidebar trigger in mobile
    activeSidebar() {
      this.$store.commit("IS_SIDEBAR_ACTIVE", !this.$store.state.isSidebarActive);
    },
    backToMasterLogin() {
      if (this.$ls.get("admin") != null) {
        this.$ls.set("user", this.$ls.get("admin"));
        location.href = "/home";
      }
    },
  },
};
</script>
